import {
    authenticatedApi,
    ApiError,
    API_BASE_URL
} from './apiUtils';

export const dashboardsApi = {
  getAllDashboards: async () => {
    try {
      return await authenticatedApi.get(`${API_BASE_URL}/dashboards`);
    } catch (error) {
      throw new ApiError('Failed to fetch dashboards', error.status || 500);
    }
  },

  createDashboard: async (dashboardData) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/dashboards`, dashboardData);
    } catch (error) {
      throw new ApiError('Failed to create dashboard', error.status || 500);
    }
  },

  updateDashboard: async (dashboardId, dashboardData) => {
    try {
      return await authenticatedApi.put(`${API_BASE_URL}/dashboards/${dashboardId}`, dashboardData);
    } catch (error) {
      throw new ApiError('Failed to update dashboard', error.status || 500);
    }
  },

  deleteDashboard: async (dashboardId) => {
    try {
      return await authenticatedApi.delete(`${API_BASE_URL}/dashboards/${dashboardId}`);
    } catch (error) {
      throw new ApiError('Failed to delete dashboard', error.status || 500);
    }
  },

  getDashboardById: async (dashboardId) => {
    try {
      return await authenticatedApi.get(`${API_BASE_URL}/dashboards/${dashboardId}`);
    } catch (error) {
      throw new ApiError('Failed to fetch dashboard data', error.status || 500);
    }
  },

  addLeafToDashboard: async (dashboardId, leafSegmentId) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/dashboards/${dashboardId}/leaves`, { leafSegmentId });
    } catch (error) {
      throw new ApiError('Failed to add leaf to dashboard', error.status || 500);
    }
  },

  removeLeafFromDashboard: async (dashboardId, leafSegmentId) => {
    try {
      return await authenticatedApi.delete(`${API_BASE_URL}/dashboards/${dashboardId}/leaves/${leafSegmentId}`);
    } catch (error) {
      throw new ApiError('Failed to remove leaf from dashboard', error.status || 500);
    }
  },

  getDashboardsByProjectId: async (projectId) => {
    try {
      return await authenticatedApi.get(`${API_BASE_URL}/projects/${projectId}/dashboards`);
    } catch (error) {
      throw new ApiError('Failed to fetch dashboards by project ID', error.status || 500);
    }
  },

  addInternalNodeToDashboard: async (dashboardId, internalSegmentId) => {
    try {
      return await authenticatedApi.post(`${API_BASE_URL}/dashboards/${dashboardId}/internal-nodes`, { internalSegmentId });
    } catch (error) {
      throw new ApiError('Failed to add internal node to dashboard', error.status || 500);
    }
  },

  removeInternalNodeFromDashboard: async (dashboardId, internalSegmentId) => {
    try {
      return await authenticatedApi.delete(`${API_BASE_URL}/dashboards/${dashboardId}/internal-nodes/${internalSegmentId}`);
    } catch (error) {
      throw new ApiError('Failed to remove internal node from dashboard', error.status || 500);
    }
  },
};